/**
 * Observer class
 */
class BlackholeService {
  constructor() {
  }

  sendEvent(logData) {
    console.log("Logs got pulled into the Blackhole");
  }
}
export default BlackholeService;



// WEBPACK FOOTER //
// ./src/modules/analyticsLibrary/BlackholeService.js